import React from 'react'
import PropTypes from 'prop-types'

import { Label, translate } from 'parking-react-common'

import { gates } from '../redux'

import List from '../components/List'
import GateButton from '../components/GateButton'

const GatesList = ({ title, subtitle, dataURL, dataSelector, t }) => {
    const columns = [
        {
            key   : 'serial_number',
            title : t('Serial number')
        },
        {
            key    : 'direction',
            title  : t('Direction'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <Label scope="gates.direction">{ cellData }</Label>
            )
        },
        {
            key    : 'button',
            title  : t('Open'),
            render : ({ rowData }) => ( // eslint-disable-line react/prop-types
                <GateButton gate={ rowData } />
            )
        }
    ]

    return (
        <List
            title={ title }
            subtitle={ subtitle }
            columns={ columns }
            dataURL={ dataURL }
            dataSelector={ dataSelector }
            searchKeys={ ['serial_number', 'direction'] }
        />
    )
}

GatesList.propTypes = {
    title        : PropTypes.node,
    subtitle     : PropTypes.node,
    dataSelector : PropTypes.func,
    dataURL      : PropTypes.string
}

GatesList.defaultProps = {
    dataSelector : gates.getAll,
    dataURL      : 'gates'
}

export default translate()(GatesList)
